import { AuthProviderForm, GenericCredentials } from '../../sessions.service';
import { signIn, fetchAuthSession } from 'aws-amplify/auth';

export class AmplifyAuthGrantType implements AmplifyAuthGrantType {
  getSignInFields(): AuthProviderForm {
    return [
      {
        key: 'username',
        label: 'Username',
        type: 'text',
        saveForPrefill: true,
        icon: 'pi pi-user',
      },
      {
        key: 'password',
        label: 'Password',
        type: 'password',
        saveForPrefill: false,
        icon: 'pi pi-key',
      },
    ];
  }

  async prepareAuthenticationPayload(credentials: GenericCredentials, _config: any): Promise<any> {
    if (!credentials['username'] || !credentials['password']) {
      throw new Error('[Amplify][StartSession] Username or password not specified');
    }
    const result = await signIn({
      username: credentials['username'],
      password: credentials['password'],
      options: {
        authFlowType: 'USER_PASSWORD_AUTH',
      },
    });
    if (!result.isSignedIn) {
      throw {
        challenge: result.nextStep.signInStep,
        info: result.nextStep,
      };
    }
    const session = await fetchAuthSession();
    return session;
  }
}
